import GrenetteBoldItalicEOT from "./grenette/grenette-bold-italic-pro.eot";
import GrenetteBoldItalicTTF from "./grenette/grenette-bold-italic-pro.ttf";
import GrenetteBoldItalicWOFF from "./grenette/grenette-bold-italic-pro.woff";
import GrenetteBoldItalicWOFF2 from "./grenette/grenette-bold-italic-pro.woff2";

import GrenetteBoldEOT from "./grenette/grenette-bold-pro.eot";
import GrenetteBoldTTF from "./grenette/grenette-bold-pro.ttf";
import GrenetteBoldWOFF from "./grenette/grenette-bold-pro.woff";
import GrenetteBoldWOFF2 from "./grenette/grenette-bold-pro.woff2";

import GrenetteItalicEOT from "./grenette/grenette-italic-pro.eot";
import GrenetteItalicTTF from "./grenette/grenette-italic-pro.ttf";
import GrenetteItalicWOFF from "./grenette/grenette-italic-pro.woff";
import GrenetteItalicWOFF2 from "./grenette/grenette-italic-pro.woff2";

import GrenetteRegularEOT from "./grenette/grenette-regular-pro.eot";
import GrenetteRegularTTF from "./grenette/grenette-regular-pro.ttf";
import GrenetteRegularWOFF from "./grenette/grenette-regular-pro.woff";
import GrenetteRegularWOFF2 from "./grenette/grenette-regular-pro.woff2";

import GraphikBoldEOT from "./graphik/Graphik-Bold-Web.eot";
import GraphikBoldSVG from "./graphik/Graphik-Bold-Web.svg";
import GraphikBoldTTF from "./graphik/Graphik-Bold-Web.ttf";
import GraphikBoldWOFF from "./graphik/Graphik-Bold-Web.woff";

import GraphikBoldItalicEOT from "./graphik/Graphik-BoldItalic-Web.eot";
import GraphikBoldItalicSVG from "./graphik/Graphik-BoldItalic-Web.svg";
import GraphikBoldItalicTTF from "./graphik/Graphik-BoldItalic-Web.ttf";
import GraphikBoldItalicWOFF from "./graphik/Graphik-BoldItalic-Web.woff";

import GraphikLightEOT from "./graphik/Graphik-Light-Web.eot";
import GraphikLightSVG from "./graphik/Graphik-Light-Web.svg";
import GraphikLightTTF from "./graphik/Graphik-Light-Web.ttf";
import GraphikLightWOFF from "./graphik/Graphik-Light-Web.woff";

import GraphikLightItalicEOT from "./graphik/Graphik-LightItalic-Web.eot";
import GraphikLightItalicSVG from "./graphik/Graphik-LightItalic-Web.svg";
import GraphikLightItalicTTF from "./graphik/Graphik-LightItalic-Web.ttf";
import GraphikLightItalicWOFF from "./graphik/Graphik-LightItalic-Web.woff";

import GraphikMediumEOT from "./graphik/Graphik-Medium-Web.eot";
import GraphikMediumSVG from "./graphik/Graphik-Medium-Web.svg";
import GraphikMediumTTF from "./graphik/Graphik-Medium-Web.ttf";
import GraphikMediumWOFF from "./graphik/Graphik-Medium-Web.woff";

import GraphikMediumItalicEOT from "./graphik/Graphik-MediumItalic-Web.eot";
import GraphikMediumItalicSVG from "./graphik/Graphik-MediumItalic-Web.svg";
import GraphikMediumItalicTTF from "./graphik/Graphik-MediumItalic-Web.ttf";
import GraphikMediumItalicWOFF from "./graphik/Graphik-MediumItalic-Web.woff";

import GraphikRegularEOT from "./graphik/Graphik-Regular-Web.eot";
import GraphikRegularSVG from "./graphik/Graphik-Regular-Web.svg";
import GraphikRegularTTF from "./graphik/Graphik-Regular-Web.ttf";
import GraphikRegularWOFF from "./graphik/Graphik-Regular-Web.woff";

import GraphikRegularItalicEOT from "./graphik/Graphik-RegularItalic-Web.eot";
import GraphikRegularItalicSVG from "./graphik/Graphik-RegularItalic-Web.svg";
import GraphikRegularItalicTTF from "./graphik/Graphik-RegularItalic-Web.ttf";
import GraphikRegularItalicWOFF from "./graphik/Graphik-RegularItalic-Web.woff";

import GraphikSemiboldEOT from "./graphik/Graphik-Semibold-Web.eot";
import GraphikSemiboldSVG from "./graphik/Graphik-Semibold-Web.svg";
import GraphikSemiboldTTF from "./graphik/Graphik-Semibold-Web.ttf";
import GraphikSemiboldWOFF from "./graphik/Graphik-Semibold-Web.woff";

import GraphikSemiboldItalicEOT from "./graphik/Graphik-SemiboldItalic-Web.eot";
import GraphikSemiboldItalicSVG from "./graphik/Graphik-SemiboldItalic-Web.svg";
import GraphikSemiboldItalicTTF from "./graphik/Graphik-SemiboldItalic-Web.ttf";
import GraphikSemiboldItalicWOFF from "./graphik/Graphik-SemiboldItalic-Web.woff";

export default {
  GrenetteBoldItalicEOT,
  GrenetteBoldItalicTTF,
  GrenetteBoldItalicWOFF,
  GrenetteBoldItalicWOFF2,
  GrenetteBoldEOT,
  GrenetteBoldTTF,
  GrenetteBoldWOFF,
  GrenetteBoldWOFF2,
  GrenetteItalicEOT,
  GrenetteItalicTTF,
  GrenetteItalicWOFF,
  GrenetteItalicWOFF2,
  GrenetteRegularEOT,
  GrenetteRegularTTF,
  GrenetteRegularWOFF,
  GrenetteRegularWOFF2,
  GraphikBoldEOT,
  GraphikBoldSVG,
  GraphikBoldTTF,
  GraphikBoldWOFF,
  GraphikBoldItalicEOT,
  GraphikBoldItalicSVG,
  GraphikBoldItalicTTF,
  GraphikBoldItalicWOFF,
  GraphikLightEOT,
  GraphikLightSVG,
  GraphikLightTTF,
  GraphikLightWOFF,
  GraphikLightItalicEOT,
  GraphikLightItalicSVG,
  GraphikLightItalicTTF,
  GraphikLightItalicWOFF,
  GraphikMediumEOT,
  GraphikMediumSVG,
  GraphikMediumTTF,
  GraphikMediumWOFF,
  GraphikMediumItalicEOT,
  GraphikMediumItalicSVG,
  GraphikMediumItalicTTF,
  GraphikMediumItalicWOFF,
  GraphikRegularEOT,
  GraphikRegularSVG,
  GraphikRegularTTF,
  GraphikRegularWOFF,
  GraphikRegularItalicEOT,
  GraphikRegularItalicSVG,
  GraphikRegularItalicTTF,
  GraphikRegularItalicWOFF,
  GraphikSemiboldEOT,
  GraphikSemiboldSVG,
  GraphikSemiboldTTF,
  GraphikSemiboldWOFF,
  GraphikSemiboldItalicEOT,
  GraphikSemiboldItalicSVG,
  GraphikSemiboldItalicTTF,
  GraphikSemiboldItalicWOFF
};
